import React from 'react'

import ContentLayout from '@lyrahealth-inc/ui-core/lib/molecules/layouts/base/ContentLayout'
import { LoadingIndicator } from '@lyrahealth-inc/ui-core-crossplatform/src/atoms/icons/LoadingIndicator'

const CalendarRoutes: React.FC = () => (
  <div>
    <ContentLayout>
      <div style={{ marginTop: '50px' }}>
        <LoadingIndicator />
      </div>
    </ContentLayout>
  </div>
)

export default CalendarRoutes
